var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._l((_vm.widgetsSettings),function(settings){return _c('div',{staticClass:"col-md-6 mb-3"},[_c('common-widget',{attrs:{"settings":settings}})],1)}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('last-errors')],1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f4d49c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/dashboard.vue
// module id = null
// module chunks = 